import type { JSX } from "react";

export interface InputErrorHelperProps {
  error: RenderableError;
}

export default function InputErrorHelper(props: InputErrorHelperProps): JSX.Element {
  const { error } = props;

  return (
    <div style={{ display: "flex", flexDirection: "row", gap: "1rem" }}>
      <div style={{ alignContent: "center" }}>⚠️</div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
          gap: "0.5rem",
        }}
      >
        {!!error.type && <h6>{String(error.type)}</h6>}
        {!!error.message && <p>{error.message}</p>}
      </div>
    </div>
  );
}

interface RenderableError {
  message?: string | null;
  type?: number | string | null;
}
